import React from 'react';
import OptionItem, { OptionItemProps } from '../OptionItem/OptionItem';

export type OptionItemListProps = {
  items: OptionItemProps[];
  className?: string;
  triggerIcon?: boolean;
};

const OptionItemList: React.FC<OptionItemListProps> = ({ items, className = '', triggerIcon = false }) => {
  return (
    <ul className={className}>
      {items?.map((item, index) => (
        <li key={item.id || index} className="mb-4 last:mb-0">
          <OptionItem
            link={item.link}
            accessory={item.accessory}
            accessoryItem={item.accessoryItem}
            label={item.label}
            onClick={item.onClick}
            subtitle={item.subtitle}
            tone={item.tone}
            disabled={item.disabled}
            increasedSize={item.increasedSize}
            shortcutText={item.shortcutText}
            isError={item.isError}
            isIcon={triggerIcon}
            accessoryBg={item.accessoryBg}
          />
        </li>
      ))}
    </ul>
  );
};

export default OptionItemList;
